/**
 * Hunt card component for mobile view
 */

import { Button } from '../common';
import './HuntCard.css';

/**
 * Card displaying a hunt entry
 * @param {Object} props - Component props
 * @param {Object} props.hunt - Hunt data
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onDelete - Delete handler
 * @returns {React.ReactElement} Card element
 */
export default function HuntCard({ hunt, onEdit, onDelete, onFoundIt }) {
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  const handleFoundIt = (e) => {
    e.stopPropagation();
    onFoundIt();
  };

  return (
    <div className="hunt-card">
      <div className="hunt-card__header">
        <h3 className="hunt-card__name">{hunt.bottle_name}</h3>
        <span className={`hunt-card__priority hunt-card__priority--${hunt.priority >= 8 ? 'high' : hunt.priority >= 4 ? 'medium' : 'low'}`}>
          {hunt.priority}
        </span>
      </div>

      {hunt.type && <div className="hunt-card__type">{hunt.type}</div>}

      <div className="hunt-card__details">
        {hunt.distilleries && (
          <p className="hunt-card__distillery">
            {hunt.distilleries.distillery_name}
          </p>
        )}
        {hunt.notes && (
          <p className="hunt-card__notes">{hunt.notes}</p>
        )}
      </div>

      <div className="hunt-card__actions">
        <Button size="sm" variant="success" onClick={handleFoundIt}>
          Found It!
        </Button>
        <Button size="sm" variant="ghost" onClick={handleEdit}>
          Edit
        </Button>
        <Button size="sm" variant="danger" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
}
